/**
 * @desc 产品BOM-保存草稿
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductBomResponseDto>;
export function request(body: defs.basics.ProductBomRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productBom/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
